import { has } from "lodash"
import { ERROR_API } from "types/error"
import { ResponsePayload } from "types/payload"
import { handleGenericApiError } from "./api-errors"

interface Params {
  method: string
  additionalHeaders?: HeadersInit
  payload?: string | unknown
  responseFormat?: "blob"
}
export const httpSuccess = (response: ResponsePayload, fields?: string) => {
  if (response.status === "ok") {
    if (fields) return has(response, fields)
    else return true
  } else return false
}
function request<T>(
  url: string,
  {
    method,
    additionalHeaders = {},
    payload = "",
    responseFormat = undefined,
  }: Params
): Promise<T> {
  const defaultHeaders: Record<string, string> = {
    "X-User-Token": sessionStorage.getItem("X-USER-Token") || "",
  }
  // No Content-Type on GET: an empty value trips WAF rule CRS 920470.
  if (method !== "GET") {
    defaultHeaders["Content-Type"] = "application/json; charset=utf-8"
  }
  const headers = Object.assign({}, defaultHeaders, additionalHeaders)
  const params: { headers: HeadersInit; method?: string; body?: BodyInit } = {
    headers,
    method,
  }

  if (payload) {
    Object.assign(params, { body: JSON.stringify(payload) })
  }

  return fetchWithTimeout(`/api${url}`, {
    ...params,
  })
    .then(handleGenericApiError)
    .then(async (response: Response | string) => {
      if (typeof response === "string") return response
      if (responseFormat === "blob" && response.status === 200) {
        const blob = await response.blob()
        return blob
      } else {
        return response.json()
      }
    })
    .then((response) => {
      if (response.jwt) sessionStorage.setItem("X-USER-Token", response.jwt)
      return response
    })
    .catch((e) => {
      throw e
    })
}

export const DEFAULT_REQUEST_TIMEOUT_MS = 10000

export const fireTimeout = async (
  func: Promise<Response>,
  time: number
): Promise<Response | unknown> => {
  return Promise.race([
    func,
    new Promise((res) =>
      setTimeout(
        () => res({ status: 408, error: ERROR_API.TIMEOUT_ERROR }),
        time
      )
    ),
  ])
}

async function fetchWithTimeout(
  resource: RequestInfo,
  options?: RequestInit
): Promise<Response> {
  const response = await fireTimeout(
    fetch(resource, {
      ...options,
    }),
    DEFAULT_REQUEST_TIMEOUT_MS
  )
  return response as Response
}

export { request }
